import React from 'react';
import PropTypes from 'prop-types';

const ItemList = ({ renderHeader, renderItem, items }) => {
  return (
    <React.Fragment>
      {typeof renderHeader === 'function' ? renderHeader(items) : renderHeader}
      {items.map(renderItem)}
    </React.Fragment>
  );
};

ItemList.propTypes = {
  renderHeader: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any),
};

ItemList.defaultProps = {
  renderHeader: items => null,
  renderItem: () => null,
  items: [],
};

export { ItemList };



// WEBPACK FOOTER //
// ./src/common/Components/ItemList/ItemList.js